module.exports = __webpack_public_path__ + "img/vg.b37358a1.svg";